//Getters
export const GET_MOVIMENTO = 'GET_MOVIMENTO'

// Actions
export const SET_MOVIMENTO_FROM_API = 'SET_MOVIMENTO_FROM_API'
export const SET_MOVIMENTO = 'SET_MOVIMENTO'